import styled from 'styled-components';

import FlexDiv from 'components/FlexDiv';

export const EmptyListStyled = styled(FlexDiv)`
  padding: 0 192px;
  width: 100%;
`;
